<template>
    <div>
        <div v-for="(items, date) in timelineData" :key="date" class="timeline-area">
            
            <div v-for="(item, index) in items" class="timeline-item-list" :key="index">
                <span v-if="index === 0" class="timeline-date">{{ date | formatDateLabel }}</span>
                <div class="timeline-item" :class="{'last': item.isLast, 'first': item.isFirst, [item.statusClassName] : true}">
                    <div class="timeline-label">    
                        <span class="timeline-user-name">
                            <span class="prefix">{{ item.action === 'create' ? 'Created by' : 'Updated by'}}</span> 
                            {{ item.creatorName }}
                        </span>
                        <span class="timeline-time">
                            <span class="prefix">at</span>
                            {{ item.creationDate | formatTimeLabel }}
                        </span>
                    </div>
                    <div class="timeline-action">
                        <div class="action-icon">
                            <b-icon :icon="getIcon(item)" style="width:45%; height: 45%;"></b-icon>
                        </div>
                    </div>
                    <div class="timeline-content">
                        <!-- Description 변경 표시 Start -->
                        <div v-if="item.changedAttributeState.description" class="timeline-content-group">
                            <span class="content-group-label">
                                Description
                            </span>
                            <div class="content-group-content">
                            <span v-if="item.changedAttributeState.description.previousValue != -1" class="prevValue">
                                <button @click="clickShowRevisionButtonHandler(item.changedAttributeState.description.previousValue)" class="show-revision-button">
                                    <span>
                                        Revision {{ item.changedAttributeState.description.previousValue + 1}}
                                    </span>
                                </button>

                                <span style="text-align:center; margin:0 0.6rem;">
                                    <b-icon icon="arrow-right"></b-icon>
                                </span>
                            </span>

                            <span class="currValue">
                                <button @click="clickShowRevisionButtonHandler(item.changedAttributeState.description.currentValue)" class="show-revision-button">
                                    <span>
                                        Revision {{ item.changedAttributeState.description.currentValue + 1 }}
                                    </span>
                                </button>
                            </span>
                        </div>
                        </div>
                        <!-- Description 변경 표시 End -->

                        <!-- Extra Field 변경 표시 Start -->
                        <template v-for="field in Object.keys(item.changedAttributeState)">
                            <div v-if="field != 'status' && field != 'description' && field != 'unread'" class="timeline-content-group">
                                <span class="content-group-label">
                                {{ field | formatFieldName }}
                                </span>
                                <div class="content-group-content">
                                    <div v-if="item.changedAttributeState[field].previousValue !== null" class="prevValue">
                                        {{ showTextByValue(field, item.changedAttributeState[field].previousValue) | isEmpty }}

                                        <span style="text-align:center; margin:0 0.6rem;">
                                            <b-icon icon="arrow-right"></b-icon>
                                        </span>
                                    </div>

                                    <div class="currValue">
                                        {{ showTextByValue(field, item.changedAttributeState[field].currentValue) | isEmpty }}
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!-- Extra Field 변경 표시 End -->
                        
                        <!-- Upload Files 표시 Start -->
                        <div v-if="item.uploadFileList.length > 0" class="timeline-content-group">
                            <span class="content-group-label">
                                Upload Files
                            </span>
                            <div class="content-group-content list">
                                <span v-for="(file, index) in item.uploadFileList" :key="index" style="display: block;">
                                {{ file }}
                                </span>
                            </div>
                        </div>
                        <!-- Upload Files 표시 End -->
                        <!-- Delete Files 표시 Start -->
                        <div v-if="item.deleteFileList.length > 0" class="timeline-content-group">
                            <span class="content-group-label">
                                Delete Files
                            </span>
                            <div class="content-group-content">
                                <span v-for="(file, index) in item.deleteFileList" :key="index" style="display: block;">
                                {{ file }}
                                </span>
                            </div>
                        </div>
                        <!-- Delete Files 표시 End -->

                        <div v-if="item.addComment != null" class="timeline-content-group">
                            <span class="content-group-label" style="border:none;">Write a comment!</span>
                        </div>
                        <!-- 관련 MeMO 연결 End -->
                        <!-- {{ JSON.stringify(item) }} -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>
<script>
import StatusBadge from '../wbs/StatusBadge.vue';


export default {

    name: "ImportTimeline",
    components: {
        StatusBadge,
    },
    props: {
        propTimelineData: {type:Object},
    },
    created() {
        // this.timelineData = JSON.parse(JSON.stringify(this.propTimelineData));        
    },
    computed: {
        timelineData() {
            const timelineObject = JSON.parse(JSON.stringify(this.propTimelineData));
            let prevStatus = ''
            let idx = 0;
            let descriptionIdx = 0;
            const maxSize = Object.keys(timelineObject).length;

            for(const date in timelineObject) {
                for(let i = 0;  i < timelineObject[date].length; i++) {
                    const event = timelineObject[date][i];

                    // status별 스타일을 줄 class 지정
                    const currStatus = event.changedAttributeState.accept;
                    if(currStatus) {
                        
                        event.statusClassName = this.classByAccept[currStatus.currentValue] || this.classByStatus['N'];
                        prevStatus = currStatus.currentValue;
                    } else {
                        event.statusClassName = this.classByAccept[prevStatus] || this.classByAccept['N'];;
                    }
                    
                    event.isFirst = i == 0 ? true : false;
                    event.isLast = idx === maxSize - 1 && i === timelineObject[date].length - 1 ? true : false;

                    // revision 번호 지정
                    // 변경된 description 내용을 보여주는 것은 
                    // 부모 컴포넌트에서 이벤트를 받아 수행
                    const description = event.changedAttributeState.description;
                    if(description) {
                        description.currentValue = descriptionIdx;
                        description.previousValue = descriptionIdx - 1;
                        descriptionIdx++;
                    }
                }
                idx++;
            }

            return timelineObject;
        },
    },
    data() {
        return {
            
            classByAccept :{
                'Y' : 'accepted',
                'N' : 'not_accepted'
            },
            statusProgressArray : [],
            
        }
    },
    methods: {
        getIcon(item) {

            // 생성 일 때
            if(item.action === 'create') return 'plus-lg';
            return 'pen-fill';
        },
        clickShowRevisionButtonHandler(revisionIdx) {
            this.$emit('showRevision', revisionIdx);
        },
        showTextByValue(fieldName, value) {
            const options = this.$store.getters[`requirement/${fieldName}Options`];
            let text = value;
            if(options) {
                const findOption = options.find(option => option.value === value);
                text = findOption ? findOption.text : value;
            }

            return text;
        },
    },
    filters: {
        formatDateLabel(dateStr) {
            const months = [
                "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
            ];

            const date = dateStr.split('-');
            const month = months[Number(date[1]) - 1];
            const day = date[2];
            const year = date[0];

            return `${month} ${day}, ${year}`;
        },
        formatTimeLabel(dateStr) {
            return dateStr.split(' ')[1];
        },
        formatFieldName(fieldName) {
            return fieldName
                .replace(/([A-Z])/g, ' $1') // 대문자 다음에 공백 추가
                .replace(/^./, str => str.toUpperCase()); 
        },
        isEmpty(value) {
            if(value === null || value === '') {
                return 'Empty'
            } else {
                return value;
            }
        }
    }
}
</script>
<style scoped>
* {
    font-family: "NanumGothic"
}
.timeline-date {
    display: inline;
    margin-left : 10rem;
    /* text-align:center; */
    padding: 0.7rem 1rem;
    background-color: #2E2E38;
    color: #FFE305;
    align-self: start;
    border-radius: 20px;
    font-weight: bold;
    z-index: 100;
}
.timeline-item-list {
    width: 100%;
    display:flex;
    flex-direction: column;
}

.timeline-item {
    display: flex;
}

.timeline-label {
    width: 10rem;
    line-height: 1.1;
    display:flex;
    flex-direction: column;
    align-items: end;
    margin: 1.666rem 1rem;
    font-weight : bold;
}
.timeline-label .prefix {
    font-size: 0.8rem;
    color: #747490;
}
.timeline-action {
    position: relative;
    width: 4rem;
    /* height: 4rem; */
    /* margin-top: 1.666rem; */
}

.timeline-action .action-icon {
    border-radius: 50%;
    border: 3px solid #E9E9ED;
    background-color: white;
    width: 2.5rem;
    height: 2.5rem;
    margin: 0 auto;
    margin-top: 1.7rem;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.timeline-item .timeline-action::before {
    content: '';
    position: absolute;
    bottom: -1.7rem;
    border: none;
    height: 100%;
    width: 3px; 
    background-color: #E9E9ED;
    margin: auto;
    left: 50%;
    transform: translateX(-50%);
    outline: none;
}


.timeline-item.first .timeline-action::before {
    height: calc(100% + 1.7rem);
}
.timeline-item.last .timeline-action::before {
    height: 0rem;
}

.timeline-item.last.first .timeline-action::before {
    height: 3rem;
    bottom: unset;
    top: 0;
}

.timeline-item.not_accepted .timeline-action::before {
    background-color: #E9E9ED;
}
.timeline-item.not_accepted .action-icon {
    border-color: #E9E9ED;
    background-color: #E9E9ED;
    color: #2E2E38;
}


/* .timeline-item.done .timeline-action::before {
    background-color: #CFDDFF;
}
.timeline-item.done .action-icon {
    background-color: #CFDDFF;
    border-color: #CFDDFF;
    color: #1755CC;
} */

.timeline-item.accepted .timeline-action::before {
    background-color: #D7F5D6;
}
.timeline-item.accepted .action-icon {
    background-color: #D7F5D6;
    border-color: #D7F5D6;
    color: #168D4C;
}

.timeline-content {
    display: flex;
    flex-direction: column;
    position: relative;
    margin: 0.933rem 3.333rem 0.933rem 1.333rem;
    justify-content:center;
    
    border: none;
    border-radius: 20px 20px 20px 20px;
    background-color:#F6F6FA;
    padding: 1rem 1rem;
    flex: 4;
}
.timeline-content:has(div.timeline-read) {
    background-color: transparent;
    font-weight: bold;
}

.timeline-content-group {
    display:flex;
}
.timeline-content-group > * {
    
    padding: 0.2rem 0;
}
.timeline-content-group .content-group-label {
    width: 10rem;
    font-weight: bold;
    border-right: 1.5px solid #E7E7EE;
    margin-right: 0.5rem;
}
.timeline-content-group .content-group-content {
    display: flex;
}
.timeline-content-group .content-group-content.list {
    flex-direction: column;
}

.show-other-chat-button,
.show-revision-button {
    padding: 0;
    width: unset;
    height: unset;
    border: none;
    background-color: transparent;
    text-decoration: underline;
    color: blue;
    display: flex;
}
.prevValue {
    display: flex;
}
</style>